export function getCollectionPermalinkPrefix(collectionType: string) {
  const prefixes = {
    tutorials: 'tutorials',
    tutorial: 'tutorials',
    guides: 'guides',
    guide: 'guides',
    articles: 'blog'
  };
  return prefixes[collectionType] || collectionType;
}
